import FastMarquee from "react-fast-marquee";

const WORDS = ["Nourish", "Renew", "Radiate", "10g Protein", "Triple Threat Formula", "Triple Thrive Formula", "Built Different"];

const Marquee = () => (
  <div className="border-y border-[#EBE8E3] py-10 md:py-14 overflow-hidden" data-testid="editorial-marquee">
    <FastMarquee speed={60} gradient={false}>
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif-lux italic font-light text-4xl md:text-6xl text-[#111111] px-8 md:px-12 whitespace-nowrap">
            {w}
          </span>
          <span className="text-[#C07C5F] text-2xl md:text-3xl">✧</span>
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default Marquee;
